import React from 'react';
import {redirect} from "../../utils/commonFunc";
import MainController from "../MainController";
function MainView(props) {
    const {
        products,searchText,setSearchText,fetchProducts
    }=MainController();
    return (<>
        <div className="search-form">
            <div>
                <input className="input-search" placeholder="Tìm kiếm sản phẩm..." type="search" name="searchtext"
                       onFocus={()=>{fetchProducts()}}
                       defaultValue={searchText} onKeyDown={() => {
                    if (event.key === 'Enter') {
                        if(searchText&& searchText?.trim()!=="") redirect("",searchText)
                    }
                }} onChange={(e) => setSearchText(e.target.value)} style={{backgroundColor:'white'}}/>
                <button className="button-search" title="Tìm kiếm" onClick={() => {
                    if(searchText&& searchText?.trim()!=="") redirect("",searchText);
                }}>
                    <i className="fa-solid fa-magnifying-glass"></i>
                </button>
            </div>
        </div>

        {products?.length > 0 && <div className="search-suggestions">
            <h5 className="search-suggestions-title">Sản phẩm gợi ý</h5>
            <ul className="search-suggestions-list">
                {products?.map(product => (<li key={product?.id} style={{cursor: 'pointer'}} onClick={() => {
                    redirect(product?.name);
                }}>
                    <i className="fa-solid fa-magnifying-glass search-suggestions-icon"></i> {product?.name}
                </li>))}
            </ul>
        </div>}
    </>)
}

export default MainView;